<template>
    <div class="settings-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
            <div class="nav-title">账号设置</div>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 用户信息卡片 -->
        <div class="info-card">
            <div class="info-item" style="padding: 15px 0;" @click="handleClick('avatar')">
                <span class="info-label">头像</span>
                <div class="info-right">
                    <img v-if="avatarUrl" :src="avatarUrl" alt="avatar" class="avatar-preview" />
                    <img v-else src="@/assets/user.png" alt="avatar" class="avatar-preview" />
                    <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
                </div>
            </div>
            <input 
                ref="avatarInput" 
                type="file" 
                accept="image/*" 
                style="display: none;" 
                @change="handleAvatarChange"
            />

            <div class="info-divider"></div>

            <div class="info-item" @click="handleClick('name')">
                <span class="info-label">名字</span>
                <div class="info-right">
                    <span class="info-value">{{ profileData.first_name }}</span>
                    <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
                </div>
            </div>

            <div class="info-divider"></div>

            <div class="info-item" @click="handleClick('phone')">
                <span class="info-label">电话</span>
                <div class="info-right">
                    <span class="info-value">{{ profileData.phone }}</span>
                    <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
                </div>
            </div>
        </div>

        <!-- 修改密码按钮 -->
        <div class="info-card">
            <div class="info-item" @click="handleClick('password')">
                <span class="info-label">修改密码</span>
                <div class="info-right">
                    <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { systemProfile } from '../api/apiList/system';

export default {
    name: 'Settings',
    data() {
        return {
            profileData: {},
            avatarUrl: ''
        }
    },
    mounted() {
        this.profileData = JSON.parse(localStorage.getItem('profileData')) || {};
        if (this.profileData.avatar) {
            this.avatarUrl = this.profileData.avatar;
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        handleAvatarChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!file.type.startsWith('image/')) {
                this.$toast('请选择图片文件');
                return;
            }

            if (file.size > 5 * 1024 * 1024) {
                this.$toast('图片大小不能超过 5MB');
                return;
            }

            const reader = new FileReader();
            reader.onload = async (e) => {
                const base64 = e.target.result;
                this.avatarUrl = base64;
                
                await this.handleChangeAvatar(base64);
            };
            reader.onerror = () => {
                this.$toast('图片读取失败');
            };
            reader.readAsDataURL(file);
        },
        async handleChangeAvatar(base64) {
            try {
                let info = await systemProfile({
                    avatar: base64
                });
                if (info.id) {
                    this.profileData.avatar = base64;
                    localStorage.setItem('profileData', JSON.stringify(this.profileData));
                    this.$toast('修改头像成功');
                }
            } catch (error) {
                this.$toast('修改头像失败');
                this.avatarUrl = this.profileData.avatar;
            }
        },
        handleClick(type) {
            switch (type) {
                case 'avatar':
                    this.$refs.avatarInput.click();
                    break;
                case 'name':
                    this.$router.push('/change-name');
                    break;
                case 'phone':
                    this.$router.push('/change-phone');
                    break;
                case 'password':
                    this.$router.push('/change-password');
                    break;
            }
        }
    }
};
</script>

<style scoped>
.settings-container {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    color: #fff;
    padding: 0;
}

/* 顶部导航栏 */
.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    position: sticky;
    top: 0;
    background-color: #000;
    z-index: 100;
}

.back-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.nav-title {
    font-size: 17px;
    font-weight: 500;
    color: #fff;
}

.nav-placeholder {
    width: 20px;
}

/* 用户信息卡片 */
.info-card {
    background-color: #1a1a1a;
    border-radius: 16px;
    padding: 0 20px;
    margin: 0 20px 20px;
}

.info-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    cursor: pointer;
    transition: opacity 0.3s ease;
}

.info-item:active {
    opacity: 0.7;
}

.info-label {
    font-size: 15px;
    color: #999;
}

.info-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar-preview {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.info-value {
    font-size: 15px;
    color: #fff;
}

.arrow-icon {
    width: 16px;
    height: 16px;
    opacity: 0.5;
}

.info-divider {
    height: 1px;
    background-color: #2a2a2a;
}
</style>
